import React from 'react';
import Seo from 'src/components/Seo';
import EditMentorDetails from 'src/components/mentor/profile/EditMentorDetails';
import MentorProfilePic from 'src/components/mentor/profile/MentorProfilePic';
import Container from 'src/components/shared/Container';
import { useUserContext } from 'src/context/UserProvider';
import { useGetUserProfile } from 'src/hooks/profile.hooks';
import seoConfig from '../seo.json';
import { UIUser } from 'types';

const MentorProfile = () => {
	const { user } = useUserContext();
	const seoInfo = seoConfig['profile'];
	const userProfileData = useGetUserProfile(user?.handler || '');
	return (
		<>
			<Seo title={seoInfo.title} description={seoInfo.description} />
			<Container className="py-6">
				<div className="flex md:flex-row flex-col md:max-w-[70%] mx-auto rounded-xl gap-2 px-2 bg-white dark:bg-[#1F2A37] justify-between py-3 min-h-[calc(100vh-20vh)]">
					<div className="md:w-[36%] h-full p-2">
						<MentorProfilePic userProfileData={userProfileData.data?.userDetail as UIUser} />
					</div>
					<div className="md:w-[65%] h-full p-2">
						<EditMentorDetails userProfileData={userProfileData.data?.userDetail as UIUser} />
					</div>
				</div>
			</Container>
		</>
	);
};

export default MentorProfile;
